import { httpClient } from '@/network/clientController'

/** Get list of possible status for a booking with an account manager
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetbookingstatus
*/
export const getAccountManagerBookingStatusList = () => {
	return httpClient({
		method: 'GET',
		url: 'booking/status',
		isCancellable: true
	})
}

/** Lists customer bookings with account manager
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetbookingappointments
*/
export const getCustomerAccountManagerBookings = payload => {
	return httpClient({
		method: 'GET',
		url: 'booking/appointments',
		params: payload
	})
}

/** Cancels a booking with the account manager
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/DELETE_internetbookingcancel%7Bid%7D?parent=Web_API
*/
export const deleteCustomerAccountManagerBookings = payload => {
	return httpClient({
		method: 'DELETE',
		url: `booking/cancel/${payload.id}`,
        params: payload.params
	})
}

/** List account manager available calendar
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetbookingcalendar
*/
export const getAccountManagerAvailableCalendar = payload => {
	return httpClient({
		method: 'GET',
		url: 'booking/calendar',
		data: payload
	})
}

/** Creates a schedule with account manager
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetbookingschedule
*/
export const createScheduleWithAccountManager = payload => {
	return httpClient({
		method: 'POST',
		url: 'booking/schedule',
		data: payload
	})
}

/** Edits a schedule with account manager
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_internetbookingupdate%7Bid%7D
*/
export const editScheduleWithAccountManager = payload => {
	return httpClient({
		method: 'PUT',
		url: `booking/update/${payload.id}`,
		data: payload.data
	})
}
